import { ResponseSchema } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  ResponseSchema,
  React
};